import digitalData from 'digital-data';
import { PIP, INTERACTION } from '../constants.js';
export const collectionList = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('collection-list.interaction', _ref => {
    let {
      output = {}
    } = _ref;
    const {
      item
    } = output;
    digitalData.event.push({
      category: {
        primaryCategory: INTERACTION
      },
      eventInfo: {
        eventName: 'product options'
      },
      pageType: PIP,
      item
    });
  });
  window.LIFE_CYCLE_EVENT_BUS.on('collection-list.data', _ref2 => {
    let {
      output = {}
    } = _ref2;
    const {
      products
    } = output;
    digitalData.content = digitalData.content || {};
    digitalData.content.product = (products || []).map(product => {
      return {
        productInfo: {
          sku: product === null || product === void 0 ? void 0 : product.itemId,
          position: product === null || product === void 0 ? void 0 : product.podPosition
        }
      };
    });
  });
};
//# sourceMappingURL=collection-list.listener.analytics.js.map